var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGuideAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 7.18747V14.4999M6.5 7.18747H2.83301C2.3663 7.18747 2.13318 7.18747 1.95492 7.27602C1.79811 7.35392 1.67072 7.47812 1.59083 7.63101C1.5 7.80481 1.5 8.0325 1.5 8.48754V14.4999H6.5M6.5 7.18747V2.80007C6.5 2.34503 6.5 2.11734 6.59083 1.94354C6.67072 1.79066 6.79811 1.66645 6.95492 1.58856C7.13317 1.5 7.3663 1.5 7.83301 1.5H10.1663C10.6331 1.5 10.8669 1.5 11.0452 1.58856C11.202 1.66645 11.329 1.79066 11.4089 1.94354C11.4997 2.11734 11.5 2.34503 11.5 2.80007V4.74998M6.5 14.4999H11.5M11.5 14.4999L16.5 14.5V6.05005C16.5 5.59501 16.4997 5.36732 16.4089 5.19352C16.329 5.04064 16.2024 4.91643 16.0456 4.83854C15.8674 4.74998 15.6334 4.74998 15.1667 4.74998H11.5M11.5 14.4999V4.74998",
    stroke: "#5E42E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuideAnalysis);
export default __webpack_public_path__ + "static/media/ic_guide_analysis.ad2d760314acd976ee02786e4c189a74.svg";
export { ForwardRef as ReactComponent };